import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=136a3157&scoped=true"
import script from "./Replace.vue?vue&type=script&lang=js"
export * from "./Replace.vue?vue&type=script&lang=js"
import style0 from "./Replace.vue?vue&type=style&index=0&id=136a3157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a3157",
  null
  
)

export default component.exports